<template>
  <ContainerScrolling @show-more="showMore">
    <div
      v-if="discussions.length"
      class="community-discussion-listing rounded-6 mt-12"
    >
      <CommunityDiscussionListingDetail
        v-for="{
          id,
          author,
          title,
          description,
          createdDate,
          type,
          repliesCount,
          votesCount,
          hasUserVoted,
        } in discussions"
        :id="id"
        :key="id"
        :author="author"
        :community="community"
        :date="createdDate"
        :description="description"
        :title="title"
        :type="type"
        :replies-count="repliesCount"
        :votes-count="votesCount"
        :has-user-voted="hasUserVoted"
      />
    </div>
    <div v-else class="mt-6 mb-14">
      There are currently no topics available. If you've got something to share,
      you can start your own by selecting the 'Start a discussion' button above.
    </div>
    <div v-if="isLoading" class="text-center my-4">
      <v-progress-circular
        indeterminate
        color="primary"
        aria-label="Loading content"
      />
    </div>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";

import CommunityDiscussionListingDetail from "~/components/communities/discussion/CommunityDiscussionListingDetail.vue";
import ContainerScrolling, {
  isAtBottomOfWindow,
} from "~/components/layout/ContainerScrolling.vue";

export default {
  name: "CommunityDiscussionListing",
  components: {
    CommunityDiscussionListingDetail,
    ContainerScrolling,
  },
  props: {
    community: { type: Object, required: true },
  },
  computed: {
    ...mapState({
      discussionsLoadedAll: (state) => state.discussionsLoadedAll,
      isLoading: (state) => state.isLoading,
    }),
    discussions() {
      return this.community.latestDiscussions.results;
    },
  },
  watch: {
    discussions() {
      if (isAtBottomOfWindow() && !this.discussionsLoadedAll) {
        this.showMore();
      }
    },
  },
  methods: {
    showMore() {
      if (this.discussionsLoadedAll || this.isLoading) {
        return;
      }

      const params = {
        communityId: this.community.id,
        skip: this.discussions.length,
        limit: 5,
        createdBefore: this.discussions[0]?.createdDate,
      };

      this.$store.dispatch("loadMoreCommunityDiscussionListing", { params });
    },
  },
};
</script>

<style lang="scss" scoped>
.community-discussion-listing {
  @include media-breakpoint-up("sm") {
    border: 1px solid var(--v-brighter-base);
  }
}
</style>
